import React from 'react';

/** A friendly empty state: an image from the bundled icon set, one warm line
 *  and, optionally, one thing to do next. Never a dead end, never a scolding. */
export const EmptyState = ({ icon, title, line, action, testId = 'play-empty-state' }) => (
    <div className="flex flex-col items-center gap-2 rounded-2xl border border-dashed border-slate-300 px-6 py-10 text-center dark:border-slate-700"
        data-testid={testId}>
        {icon ? <img src={icon} alt="" aria-hidden="true" width={56} height={56} className="play-float" /> : null}
        <p className="text-base font-bold text-slate-800 dark:text-slate-100">{title}</p>
        {line ? <p className="max-w-xs text-sm text-slate-500 dark:text-slate-400">{line}</p> : null}
        {action}
    </div>
);

export default EmptyState;
